import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { validateEnv } from './utils/env';

// Vérification des variables d'environnement
try {
    validateEnv();
} catch (error) {
    console.error('Erreur de configuration :', error.message);
    // Afficher un message d'erreur dans le DOM
    const root = document.getElementById('root');
    root.innerHTML = `
        <div style="
            padding: 20px;
            margin: 20px;
            border: 1px solid #ff0000;
            border-radius: 4px;
            background-color: #fff5f5;
            color: #ff0000;
        ">
            <h2>Erreur de configuration</h2>
            <p>${error.message}</p>
            <p>Veuillez vérifier votre fichier .env et redémarrer l'application.</p>
        </div>
    `;
    throw error;
}

// Intégration Google Analytics 4
if (typeof window !== 'undefined' && !window.GA_INITIALIZED) {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-9DBY7LFY9R';
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-9DBY7LFY9R');
  `;
  document.head.appendChild(script2);
  window.GA_INITIALIZED = true;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 